import PrimaryButton from "components/buttons/primary-button";
import TextInput from "components/inputs/text-input";
import Typography from "components/typography";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  close: () => void;
  confirm: Function;
}
const SetUpArtist = ({ close, confirm }: IProps) => {
  const [loading, setLoading] = useState(false);
  const [artistName, setArtistName] = useState("");

  const OnSetUp = async () => {
    setLoading(true);
    await confirm();
    setLoading(false);
  };

  return (
    <Container>
      <Header>
        <Typography color={Colors.white300} weight="semibold">
          Set Up Your Artist
        </Typography>
        <CancelIcon onClick={close}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M15.8327 4.1665L4.16602 15.8332M4.16602 4.1665L15.8327 15.8332"
              stroke="#DDDDDD"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </CancelIcon>
      </Header>
      <Body>
        <Typography mb="2.4">
          Let’s get started by setting up an artist, please provide the name of
          the artist .
        </Typography>
        <TextInput
          label="Artist Name"
          required
          placeholder="Enter your Artist’s  Name"
          value={artistName}
          onChange={(e) => setArtistName(e.target.value)}
        />
      </Body>
      <Footer>
        <PrimaryButton
          text="Create Artist"
          loading={loading}
          onClick={OnSetUp}
          disabled={artistName.length === 0}
        />
      </Footer>
    </Container>
  );
};

export default SetUpArtist;

const Container = styled.div`
  border-radius: 0.8rem;
  width: 53.4rem;
  overflow: hidden;
  background-color: ${Colors.grey1000};
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;

const Header = styled.div`
  width: 100%;
  padding: 1.6rem;
  background-color: ${Colors.grey700};
  border-bottom: 0.5px solid ${Colors.grey600};
  background: var(--Grey-700, #1e1e1e);
  display: flex;
  justify-content: space-between;
`;

const CancelIcon = styled.div`
  cursor: pointer;
  width: 2rem;
  height: 2rem;
`;

const Body = styled.div`
  background-color: ${Colors.grey1000};
  border-bottom: 0.5px solid ${Colors.grey600};
  padding: 3.9rem 2.5rem;
`;

const Footer = styled.div`
  width: 100%;
  padding: 2rem 2.5rem;
`;
